/* ============================================================
   Vutoria — theme behaviour
   Replaces the React/Radix layer from the Lovable build with
   vanilla JS on top of Shopify's native cart + section APIs.
   ============================================================ */
(function () {
  "use strict";

  var money = function (cents) {
    var fmt = (window.VutoriaTheme && window.VutoriaTheme.moneyFormat) || "${{amount}}";
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var withSep = parts.join(".");
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withSep)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(".", ","))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0]);
  };

  var t = function (key, fallback) {
    var d = (window.VutoriaTheme && window.VutoriaTheme.strings) || {};
    return d[key] || fallback || key;
  };

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /** Shopify's route prefix, with a fallback so a missing global can never
      take the whole cart down. */
  function shopRoot() {
    var shop = window.Shopify;
    return (shop && shop.routes && shop.routes.root) || "/";
  }

  /* ---------------- toasts ---------------- */
  var toastHost;
  function toast(msg) {
    if (!toastHost) {
      toastHost = document.createElement("div");
      toastHost.className = "vut-toasts";
      document.body.appendChild(toastHost);
    }
    var el = document.createElement("div");
    el.className = "vut-toast";
    el.setAttribute("role", "status");
    el.textContent = msg;
    toastHost.appendChild(el);
    setTimeout(function () {
      el.style.opacity = "0";
      el.style.transition = "opacity .3s";
      setTimeout(function () { el.remove(); }, 320);
    }, 3200);
  }

  /* ---------------- overlay / focus trap ---------------- */
  var overlay;
  var openLayers = [];

  function ensureOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement("div");
    overlay.className = "vut-overlay";
    overlay.addEventListener("click", function () { closeTop(); });
    document.body.appendChild(overlay);
    return overlay;
  }

  function trapFocus(e, root) {
    if (e.key !== "Tab") return;
    var focusables = $$(
      'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])',
      root
    ).filter(function (el) { return el.offsetParent !== null; });
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function openLayer(el, opts) {
    opts = opts || {};
    ensureOverlay().classList.add("is-open");
    el.classList.add("is-open");
    el.removeAttribute("aria-hidden");
    document.body.style.overflow = "hidden";
    var layer = { el: el, restoreTo: document.activeElement, onClose: opts.onClose };
    layer.keyHandler = function (e) {
      if (e.key === "Escape") { e.preventDefault(); closeTop(); }
      trapFocus(e, el);
    };
    document.addEventListener("keydown", layer.keyHandler);
    openLayers.push(layer);
    var focusTarget = el.querySelector("[data-autofocus]") || el.querySelector("button,input,a[href]");
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 60);
  }

  function closeLayer(layer) {
    layer.el.classList.remove("is-open");
    layer.el.setAttribute("aria-hidden", "true");
    document.removeEventListener("keydown", layer.keyHandler);
    if (layer.restoreTo && layer.restoreTo.focus) layer.restoreTo.focus();
    if (layer.onClose) layer.onClose();
  }

  function closeTop() {
    var layer = openLayers.pop();
    if (!layer) return;
    closeLayer(layer);
    if (!openLayers.length) {
      if (overlay) overlay.classList.remove("is-open");
      document.body.style.overflow = "";
    }
  }

  function closeById(id) {
    var idx = -1;
    for (var i = 0; i < openLayers.length; i++) {
      if (openLayers[i].el.id === id) { idx = i; break; }
    }
    if (idx < 0) return;
    closeLayer(openLayers[idx]);
    openLayers.splice(idx, 1);
    if (!openLayers.length) {
      if (overlay) overlay.classList.remove("is-open");
      document.body.style.overflow = "";
    }
  }

  /* declarative open/close: data-vut-open="#id" / data-vut-close */
  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-vut-open]");
    if (opener) {
      var target = $(opener.getAttribute("data-vut-open"));
      if (target) { e.preventDefault(); openLayer(target); }
      return;
    }
    var closer = e.target.closest("[data-vut-close]");
    if (closer) {
      e.preventDefault();
      var explicit = closer.getAttribute("data-vut-close");
      if (explicit) closeById(explicit.replace("#", ""));
      else closeTop();
    }
  });

  /* ---------------- accordions ---------------- */
  document.addEventListener("click", function (e) {
    var trig = e.target.closest(".vut-acc__trigger");
    if (!trig) return;
    var item = trig.closest(".vut-acc__item");
    var group = trig.closest(".vut-acc");
    var wasOpen = item.classList.contains("is-open");
    if (group && group.hasAttribute("data-single")) {
      $$(".vut-acc__item", group).forEach(function (i) {
        i.classList.remove("is-open");
        var b = $(".vut-acc__trigger", i);
        if (b) b.setAttribute("aria-expanded", "false");
      });
    }
    item.classList.toggle("is-open", !wasOpen);
    trig.setAttribute("aria-expanded", String(!wasOpen));
  });

  /* ============================================================
     CART — server-rendered drawer via the Section Rendering API

     The drawer markup comes from sections/cart-drawer.liquid, so Liquid can
     use variant.compare_at_price for the struck-through subtotal. The AJAX
     cart API does not expose that field, which is why the totals are not
     assembled in the browser.
     ============================================================ */
  var CART_SECTION = "cart-drawer";

  var Cart = {
    state: null,

    async fetchState() {
      var res = await fetch(shopRoot() + "cart.js", { headers: { Accept: "application/json" } });
      Cart.state = await res.json();
      Cart.paintCount();
      return Cart.state;
    },

    /** Swap the drawer with freshly rendered markup, keeping it open. */
    swap(html) {
      if (!html) return;
      var current = $("[data-cart-drawer]");
      if (!current) return;
      var wasOpen = current.classList.contains("is-open");

      var parsed = document.createElement("div");
      parsed.innerHTML = html;
      var next = parsed.querySelector("[data-cart-drawer]");
      if (!next) return;

      if (wasOpen) next.classList.add("is-open");
      next.setAttribute("aria-hidden", wasOpen ? "false" : "true");
      current.replaceWith(next);

      // the open-layer bookkeeping points at the old node
      openLayers.forEach(function (layer) {
        if (layer.el === current) layer.el = next;
      });
      startTimer();
    },

    async refresh() {
      try {
        var res = await fetch(shopRoot() + "?sections=" + CART_SECTION, {
          headers: { Accept: "application/json" }
        });
        var data = await res.json();
        Cart.swap(data[CART_SECTION]);
      } catch (e) { /* drawer keeps its last good state */ }
      return Cart.fetchState();
    },

    paintCount() {
      var s = Cart.state;
      if (!s) return;
      $$("[data-cart-count]").forEach(function (el) {
        el.textContent = s.item_count;
        el.hidden = s.item_count === 0;
      });
    },

    /**
     * Add, then VERIFY the cart really changed. Shopify can answer 200 and
     * still not add the line (sandboxed previews), so we escalate instead of
     * trusting the status code.
     */
    async add(items) {
      var before = 0;
      try {
        var pre = await Cart.fetchState();
        before = (pre && pre.item_count) || 0;
      } catch (e) { before = 0; }

      function post(body, headers) {
        return fetch(shopRoot() + "cart/add.js", {
          method: "POST", credentials: "same-origin", headers: headers, body: body
        });
      }

      var res = await post(JSON.stringify({ items: items, sections: CART_SECTION }), {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest"
      });
      if (!res.ok) {
        var err = await res.json().catch(function () { return {}; });
        throw new Error(err.description || err.message || t("cartError", "Could not add to cart."));
      }
      var payload = await res.json().catch(function () { return {}; });

      var after = await Cart.fetchState();
      if (after && after.item_count > before) {
        if (payload.sections && payload.sections[CART_SECTION]) Cart.swap(payload.sections[CART_SECTION]);
        else await Cart.refresh();
        return true;
      }

      if (window.console) console.warn("[vutoria] JSON add did not change the cart, retrying form-encoded");
      for (var i = 0; i < items.length; i++) {
        var fd = new FormData();
        fd.append("id", items[i].id);
        fd.append("quantity", items[i].quantity);
        fd.append("sections", CART_SECTION);
        await post(fd, { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" });
      }

      after = await Cart.fetchState();
      if (after && after.item_count > before) { await Cart.refresh(); return true; }

      throw new Error(t("cartUnavailable", "Cart could not be updated here — opening the full page."));
    },

    async change(key, quantity) {
      var res = await fetch(shopRoot() + "cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity, sections: CART_SECTION })
      });
      var data = await res.json().catch(function () { return {}; });
      Cart.state = data;
      Cart.paintCount();
      if (data.sections && data.sections[CART_SECTION]) Cart.swap(data.sections[CART_SECTION]);
      else await Cart.refresh();
    }
  };

  /* ---------------- reservation countdown ---------------- */
  var timerHandle;
  function startTimer() {
    var el = $("[data-cart-timer]");
    if (!el) { clearInterval(timerHandle); return; }
    var minutes = Number(el.getAttribute("data-minutes") || 5);
    clearInterval(timerHandle);

    var KEY = "vutoria:cart-hold";
    var span = minutes * 60 * 1000;
    var until = Number(sessionStorage.getItem(KEY) || 0);
    if (!until || until < Date.now()) {
      until = Date.now() + span;
      sessionStorage.setItem(KEY, String(until));
    }

    function tick() {
      var left = until - Date.now();
      if (left <= 0) {
        // The hold simply renews rather than expiring the cart.
        until = Date.now() + span;
        sessionStorage.setItem(KEY, String(until));
        left = span;
      }
      var total = Math.floor(left / 1000);
      var m = Math.floor(total / 60);
      var sec = total % 60;
      el.textContent = (m < 10 ? "0" : "") + m + ":" + (sec < 10 ? "0" : "") + sec;
    }
    tick();
    timerHandle = setInterval(tick, 1000);
  }

  /* ============================================================
     BUNDLE PICKS — colour and size are chosen, never guessed
     ============================================================ */
  function bundleData(card) {
    if (card._vutData !== undefined) return card._vutData;
    var tag = card.querySelector("[data-bundle-variants]");
    try { card._vutData = tag ? JSON.parse(tag.textContent) : null; }
    catch (e) { card._vutData = null; }
    return card._vutData;
  }

  function bundleIndex(data, matcher) {
    for (var i = 0; i < data.options.length; i++) {
      if (matcher.test(data.options[i])) return i;
    }
    return -1;
  }

  /**
   * Resolve the picked variant.
   * Returns { variant } when complete, or { missing: "colour" | "size" |
   * "combination" } so the shopper is told what is actually wrong.
   */
  function bundleResolve(card) {
    var data = bundleData(card);
    if (!data) return { missing: "size" };
    var ci = bundleIndex(data, /colou?r|farbe/i);
    var si = bundleIndex(data, /size|gr(ö|o)sse/i);
    var colour = card.getAttribute("data-colour");
    var sizeEl = card.querySelector("[data-bundle-size]");
    var size = sizeEl ? sizeEl.value : "";

    // Only demand a choice the shopper can actually make. If the card has no
    // control for an option, requiring it would deadlock the Add button.
    var hasSwatches = !!card.querySelector("[data-bundle-colour]");
    if (ci >= 0 && hasSwatches && !colour) return { missing: "colour" };
    if (si >= 0 && sizeEl && !size) return { missing: "size" };
    if (ci >= 0 && !hasSwatches) colour = null;
    if (si >= 0 && !sizeEl) size = null;

    var match = data.variants.find(function (v) {
      if (!v.available) return false;
      if (ci >= 0 && colour && v.options[ci] !== colour) return false;
      if (si >= 0 && size && v.options[si] !== size) return false;
      return true;
    });
    if (match) return { variant: match };
    return { missing: "combination" };
  }

  /** Reflect the picks and grey out sizes the chosen colour does not come in. */
  function bundlePaint(card) {
    var data = bundleData(card);
    if (!data) return;
    var ci = bundleIndex(data, /colou?r|farbe/i);
    var si = bundleIndex(data, /size|gr(ö|o)sse/i);
    var colour = card.getAttribute("data-colour");

    $$("[data-bundle-colour]", card).forEach(function (dot) {
      dot.classList.toggle("is-active", dot.getAttribute("data-bundle-colour") === colour);
    });
    var label = card.querySelector("[data-bundle-colour-label]");
    if (label && colour) label.textContent = colour;

    var sizeEl = card.querySelector("[data-bundle-size]");
    if (sizeEl && si >= 0) {
      $$("option", sizeEl).forEach(function (opt) {
        if (!opt.value) return;
        opt.disabled = !data.variants.some(function (v) {
          if (!v.available) return false;
          if (ci >= 0 && colour && v.options[ci] !== colour) return false;
          return v.options[si] === opt.value;
        });
      });
      // Remember the shopper's choice. Switching colour used to silently wipe
      // the selected size, so the next tap on Add complained about a size the
      // shopper had already picked.
      var wanted = card.getAttribute("data-size") || sizeEl.value;
      if (wanted) {
        var stillThere = $$("option", sizeEl).some(function (o) {
          return o.value === wanted && !o.disabled;
        });
        if (stillThere) {
          sizeEl.value = wanted;
          card.removeAttribute("data-size-dropped");
        } else {
          sizeEl.value = "";
          // Flag it so we can say *why* rather than repeating "select size".
          card.setAttribute("data-size-dropped", wanted);
        }
      }
    }

    var state = bundleResolve(card);
    card.classList.toggle("is-ready", !!state.variant);
    var picker = card.querySelector("[data-bundle-picker]");
    if (picker && state.variant) picker.classList.remove("is-missing");
  }

  document.addEventListener("click", function (e) {
    var dot = e.target.closest("[data-bundle-colour]");
    if (!dot) return;
    e.preventDefault();
    var card = dot.closest("[data-bundle-card]");
    card.setAttribute("data-colour", dot.getAttribute("data-bundle-colour"));
    bundlePaint(card);
  });

  document.addEventListener("change", function (e) {
    var sel = e.target.closest("[data-bundle-size]");
    if (!sel) return;
    var card = sel.closest("[data-bundle-card]");
    if (sel.value) card.setAttribute("data-size", sel.value);
    else card.removeAttribute("data-size");
    card.removeAttribute("data-size-dropped");
    bundlePaint(card);
  });

  /* ---------------- add to cart ---------------- */
  /** True inside the theme editor, whose preview keeps no cart. */
  function inEditor() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  /** Post the given items with a real <form>, bypassing fetch entirely. */
  function nativeAdd(items) {
    var item = items[0];
    if (!item || !item.id) return;
    var form = document.createElement("form");
    form.method = "post";
    form.action = shopRoot() + "cart/add";
    form.style.display = "none";
    form.appendChild(field("id", item.id));
    form.appendChild(field("quantity", item.quantity || 1));
    document.body.appendChild(form);
    form.submit();
  }

  function field(name, value) {
    var input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    return input;
  }

  async function submitAdd(btn, items) {
    var label = btn.querySelector("span") || btn;
    var original = label.textContent;
    btn.disabled = true;
    label.textContent = t("adding", "Adding…");
    try {
      await Cart.add(items);
      var drawer = $("[data-cart-drawer]");
      if (drawer) openLayer(drawer);
    } catch (err) {
      if (window.console) console.error("[vutoria] add to cart failed:", err);
      if (inEditor()) {
        toast(t("cartDesignMode", "The theme editor preview does not keep a cart. Use Preview or the live store to test."));
      } else {
        nativeAdd(items);
      }
      return;
    } finally {
      btn.disabled = false;
      label.textContent = original;
    }
  }

  /* PDP: intercept the native product form. Without JS the form still posts
     to /cart/add on its own, so adding never depends on this script. */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("#vut-buy-form");
    if (!form) return;

    var vid = form.querySelector("[data-variant-id]");
    var btn = form.querySelector("[data-main-atc]") || form;

    if (!vid || !vid.value) {
      e.preventDefault();
      var sizeDialog = $("#vut-size-dialog");
      if (sizeDialog) openLayer(sizeDialog);
      else toast(t("selectSizePlaceholder", "Please select size"));
      return;
    }

    e.preventDefault();
    var qtyInput = form.querySelector("[data-qty-input]");
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    submitAdd(btn, [{ id: Number(vid.value), quantity: qty }]);
  });

  /* Quick-add buttons: product cards, the sticky bar and bundle picks. */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-add-to-cart], .vut-bundle__add");
    if (!btn) return;

    var direct = btn.getAttribute("data-add-to-cart");

    var sticky = btn.closest("[data-sticky-atc]");
    if (sticky && !direct) {
      e.preventDefault();
      var buyForm = $("#vut-buy-form");
      if (buyForm) {
        if (buyForm.requestSubmit) buyForm.requestSubmit();
        else buyForm.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
      }
      return;
    }

    // Bundle card with options: reveal the picker, then add the resolved variant.
    var card = btn.closest("[data-bundle-card]");
    if (card && card.querySelector("[data-bundle-picker]")) {
      e.preventDefault();
      var picker = card.querySelector("[data-bundle-picker]");
      if (picker.hidden) { picker.hidden = false; bundlePaint(card); return; }

      var state = bundleResolve(card);
      if (!state.variant) {
        picker.classList.add("is-missing");
        var dropped = card.getAttribute("data-size-dropped");
        if (dropped) {
          toast(t("sizeUnavailable", "Size [size] is not available in this colour.")
            .replace("[size]", dropped));
        } else if (state.missing === "colour") {
          toast(t("selectColour", "Please choose a colour."));
        } else if (state.missing === "combination") {
          toast(t("comboUnavailable", "That combination is sold out."));
        } else {
          toast(t("selectSizePlaceholder", "Please select size"));
        }
        return;
      }
      if (btn.classList.contains("is-added")) return;
      var addedLbl = btn.getAttribute("data-added-label");
      submitAdd(btn, [{ id: state.variant.id, quantity: 1 }]).then(function () {
        if (!addedLbl) return;
        btn.classList.add("is-added");
        (btn.querySelector("span") || btn).textContent = addedLbl;
      });
      return;
    }

    if (!direct) return;
    e.preventDefault();

    var added = btn.getAttribute("data-added-label");
    if (added && btn.classList.contains("is-added")) return;
    submitAdd(btn, [{ id: Number(direct), quantity: 1 }]).then(function () {
      if (!added) return;
      btn.classList.add("is-added");
      (btn.querySelector("span") || btn).textContent = added;
    });
  });

  /* ---------------- cart line controls ---------------- */
  function lineQty(key) {
    var state = Cart.state;
    if (!state || !state.items) return 0;
    var item = state.items.find(function (i) { return i.key === key; });
    return item ? item.quantity : 0;
  }

  document.addEventListener("click", function (e) {
    var inc = e.target.closest("[data-cart-inc]");
    var dec = e.target.closest("[data-cart-dec]");
    var rem = e.target.closest("[data-cart-remove]");
    if (inc) {
      var k = inc.getAttribute("data-cart-inc");
      Cart.change(k, lineQty(k) + 1);
    } else if (dec) {
      var k2 = dec.getAttribute("data-cart-dec");
      Cart.change(k2, Math.max(0, lineQty(k2) - 1));
    } else if (rem) {
      Cart.change(rem.getAttribute("data-cart-remove"), 0);
    }
  });

  /* ============================================================
     WISHLIST — localStorage (replaces the Zustand store)
     ============================================================ */
  var Wishlist = {
    KEY: "vutoria:wishlist",
    read: function () {
      try { return JSON.parse(localStorage.getItem(Wishlist.KEY) || "[]"); }
      catch (e) { return []; }
    },
    write: function (list) {
      localStorage.setItem(Wishlist.KEY, JSON.stringify(list));
      Wishlist.paint();
    },
    has: function (handle) {
      return Wishlist.read().some(function (i) { return i.handle === handle; });
    },
    toggle: function (item) {
      var list = Wishlist.read();
      var idx = list.findIndex(function (i) { return i.handle === item.handle; });
      if (idx >= 0) { list.splice(idx, 1); toast(t("removedFromWishlist", "Removed from wishlist")); }
      else { list.push(item); toast(t("savedToWishlist", "Saved to wishlist")); }
      Wishlist.write(list);
    },
    paint: function () {
      var list = Wishlist.read();
      $$("[data-wishlist-toggle]").forEach(function (btn) {
        var on = list.some(function (i) { return i.handle === btn.getAttribute("data-handle"); });
        btn.setAttribute("aria-pressed", String(on));
        btn.setAttribute("aria-label", on ? t("saved", "Saved to wishlist") : t("save", "Save to wishlist"));
      });
      $$("[data-wishlist-count]").forEach(function (el) {
        el.textContent = list.length;
        el.hidden = list.length === 0;
      });
      var body = $("[data-wishlist-body]");
      if (!body) return;
      if (!list.length) {
        body.innerHTML =
          '<div class="vut-cart__empty"><p>' + t("wishlistEmpty", "Your wishlist is empty.") + "</p>" +
          '<p style="margin-top:.5rem;font-size:.8125rem">' + t("wishlistEmptyHint", "Tap the heart on a product to save it here.") + "</p></div>";
        return;
      }
      body.innerHTML = list.map(function (i) {
        return (
          '<div class="vut-cart__line no-lift">' +
            (i.image ? '<img src="' + i.image + '" alt="" loading="lazy">' : "") +
            '<div class="vut-cart__line-meta">' +
              '<a href="' + i.url + '" class="vut-cart__line-title">' + i.title + "</a>" +
              '<p class="vut-cart__line-price">' + i.price + "</p>" +
            "</div>" +
            '<button type="button" class="vut-cart__remove" data-wishlist-remove="' + i.handle + '">' +
              t("remove", "Remove") + "</button>" +
          "</div>"
        );
      }).join("");
    }
  };

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-wishlist-toggle]");
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      Wishlist.toggle({
        handle: btn.getAttribute("data-handle"),
        title: btn.getAttribute("data-title"),
        url: btn.getAttribute("data-url"),
        image: btn.getAttribute("data-image"),
        price: btn.getAttribute("data-price")
      });
      return;
    }
    var rem = e.target.closest("[data-wishlist-remove]");
    if (rem) {
      var list = Wishlist.read().filter(function (i) { return i.handle !== rem.getAttribute("data-wishlist-remove"); });
      Wishlist.write(list);
    }
  });

  /* ============================================================
     PREDICTIVE SEARCH
     ============================================================ */
  function initSearch(root) {
    var input = $("[data-search-input]", root);
    var results = $("[data-search-results]", root);
    var clear = $("[data-search-clear]", root);
    if (!input || !results || !once(root, "Search")) return;
    var timer;

    function hide() { results.hidden = true; }

    input.addEventListener("input", function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (!q) { hide(); return; }
      timer = setTimeout(function () {
        results.hidden = false;
        results.innerHTML = '<div class="vut-search__state">' + t("searching", "Searching…") + "</div>";
        var url = shopRoot() +
          "search/suggest.json?q=" + encodeURIComponent(q) +
          "&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last";
        fetch(url, { headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              results.innerHTML = '<div class="vut-search__state">' + t("noProducts", "No products found") + "</div>";
              return;
            }
            results.innerHTML =
              '<div class="vut-search__list">' +
              products.map(function (p) {
                var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || "");
                return (
                  '<a class="vut-search__hit no-lift" href="' + p.url + '">' +
                    (img ? '<img src="' + img + '" alt="" loading="lazy">' : "") +
                    '<span style="min-width:0;flex:1">' +
                      '<span class="vut-search__hit-vendor" style="display:block">' + (p.vendor || "VUTORIA") + "</span>" +
                      '<span class="vut-search__hit-title" style="display:block">' + p.title + "</span>" +
                      '<span class="vut-search__hit-price" style="display:block">' + (p.price ? money(p.price) : "") + "</span>" +
                    "</span>" +
                  "</a>"
                );
              }).join("") +
              "</div>" +
              '<div class="vut-search__all"><a href="' + shopRoot() + "search?q=" + encodeURIComponent(q) + '">' +
                t("showAllResults", "Show all results") + "</a></div>";
          })
          .catch(function () {
            results.innerHTML = '<div class="vut-search__state">' + t("noProducts", "No products found") + "</div>";
          });
      }, 180);
    });

    if (clear) {
      clear.addEventListener("click", function () { input.value = ""; hide(); input.focus(); });
    }
    document.addEventListener("click", function (e) {
      if (!root.contains(e.target)) hide();
    });
  }

  /* ============================================================
     PDP — gallery, variants, sticky bar
     ============================================================ */
  function initProduct() {
    var form = $("[data-product-form]");
    if (!form) return;

    var data = window.VutoriaProduct;
    if (!data) return;

    var selected = {};
    data.options.forEach(function (o, i) {
      // size stays unselected on load, exactly like the Lovable PDP
      if (/size|gr(ö|o)sse/i.test(o.name)) return;
      var first = data.variants.find(function (v) { return v.available; }) || data.variants[0];
      if (first) selected[o.name] = first.options[i];
    });

    var stage = $("[data-gallery-stage]");
    var thumbs = $$("[data-gallery-thumb]");

    function setImage(index) {
      if (!stage) return;
      var img = data.images[index];
      if (!img || !img.large) return;
      stage.src = img.large;
      thumbs.forEach(function (th) {
        th.classList.toggle("is-active", Number(th.getAttribute("data-index")) === index);
      });
    }

    thumbs.forEach(function (th) {
      if (!once(th, "Thumb")) return;
      th.addEventListener("click", function () { setImage(Number(th.getAttribute("data-index"))); });
    });

    function currentVariant() {
      return data.variants.find(function (v) {
        return data.options.every(function (o, i) { return selected[o.name] === v.options[i]; });
      }) || null;
    }

    function sizeAvailable(optionName, value) {
      return data.variants.some(function (v) {
        if (!v.available) return false;
        return data.options.every(function (o, i) {
          if (o.name === optionName) return v.options[i] === value;
          if (!selected[o.name]) return true;
          return selected[o.name] === v.options[i];
        });
      });
    }

    function paint() {
      var v = currentVariant();

      var vidInput = $("[data-variant-id]", form);
      if (vidInput) vidInput.value = v ? v.id : "";

      var priceEl = $("[data-price]");
      var cmpEl = $("[data-compare]");
      if (v && priceEl) priceEl.textContent = money(v.price);
      // Only touch the struck-through price once a variant is actually
      // resolved. Before that, Liquid's product-level value stays on screen.
      if (cmpEl && v) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          cmpEl.textContent = money(v.compare_at_price);
          cmpEl.hidden = false;
        } else {
          cmpEl.hidden = true;
        }
      }

      var atc = $("[data-main-atc]", form);
      if (atc) {
        if (v && !v.available) { atc.disabled = true; atc.textContent = t("soldOut", "Sold Out"); }
        else { atc.disabled = false; atc.textContent = t("addToCart", "Add to Cart"); }
      }

      // colour / other option swatches
      $$("[data-option-value]").forEach(function (btn) {
        var name = btn.getAttribute("data-option-name");
        btn.classList.toggle("is-active", selected[name] === btn.getAttribute("data-option-value"));
      });
      $$("[data-option-current]").forEach(function (el) {
        el.textContent = selected[el.getAttribute("data-option-current")] || "—";
      });

      // size dialog availability + trigger label
      $$("[data-size-value]").forEach(function (btn) {
        var name = btn.getAttribute("data-size-name");
        var val = btn.getAttribute("data-size-value");
        btn.disabled = !sizeAvailable(name, val);
        btn.classList.toggle("is-active", selected[name] === val);
      });
      var trigger = $("[data-size-trigger-label]");
      if (trigger) {
        var sizeOpt = data.options.find(function (o) { return /size|gr(ö|o)sse/i.test(o.name); });
        trigger.textContent = sizeOpt && selected[sizeOpt.name]
          ? sizeOpt.name + ": " + selected[sizeOpt.name]
          : t("selectSizePlaceholder", "Please select size");
      }

      // jump gallery to the colour's image
      if (v && typeof v.image_index === "number" && v.image_index >= 0) {
        setImage(v.image_index);
      }

      // sticky bar mirrors the price
      var stickyPrice = $("[data-sticky-price]");
      if (stickyPrice && v) stickyPrice.textContent = money(v.price);
    }

    document.addEventListener("click", function (e) {
      var opt = e.target.closest("[data-option-value]");
      if (opt) {
        selected[opt.getAttribute("data-option-name")] = opt.getAttribute("data-option-value");
        paint();
        return;
      }
      var size = e.target.closest("[data-size-value]");
      if (size && !size.disabled) {
        selected[size.getAttribute("data-size-name")] = size.getAttribute("data-size-value");
        paint();
        closeById("vut-size-dialog");
      }
    });

    // quantity
    $$("[data-qty-step]").forEach(function (btn) {
      if (!once(btn, "Qty")) return;
      btn.addEventListener("click", function () {
        var input = $("[data-qty-input]", form);
        var step = Number(btn.getAttribute("data-qty-step"));
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
      });
    });

    // bundle & save tiers
    $$("[data-bundle-tier]").forEach(function (tier) {
      if (!once(tier, "Tier")) return;
      tier.addEventListener("click", function () {
        $$("[data-bundle-tier]").forEach(function (x) { x.classList.remove("is-active"); });
        tier.classList.add("is-active");
        var hidden = $("[data-bundle-selected]", form);
        if (hidden) hidden.value = tier.getAttribute("data-bundle-tier");
      });
    });

    // sticky mobile add-to-cart, mirrors the IntersectionObserver from the React build
    var mainBtn = $("[data-add-to-cart]", form);
    var sticky = $("[data-sticky-atc]");
    if (mainBtn && sticky && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry) return;
        sticky.classList.toggle("is-visible", !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(mainBtn);
    }

    paint();
  }

  /* ============================================================
     COLLECTION FILTERS — submit on change, no page-jump
     ============================================================ */
  function initFilters() {
    var form = $("[data-filter-form]");
    if (!form || !once(form, "Filter")) return;
    form.addEventListener("change", function () {
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
    $$("[data-filter-clear]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        window.location.href = window.location.pathname;
      });
    });
  }

  /* ============================================================
     SOCIAL VIDEO RAIL — click to play, one at a time
     ============================================================ */
  function initVideos() {
    $$("[data-video-item]").forEach(function (item) {
      var vid = $("video", item);
      if (!vid || !once(item, "Video")) return;
      item.addEventListener("click", function () {
        $$("[data-video-item]").forEach(function (other) {
          if (other === item) return;
          var v = $("video", other);
          if (v) { v.pause(); other.classList.remove("is-playing"); }
        });
        if (vid.paused) { vid.play(); item.classList.add("is-playing"); }
        else { vid.pause(); item.classList.remove("is-playing"); }
      });
    });
  }

  /* ============================================================
     NEWSLETTER / CONTACT forms — native Shopify endpoints
     ============================================================ */
  function initForms() {
    $$("[data-ajax-form]").forEach(function (form) {
      if (!once(form, "AjaxForm")) return;
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var fd = new FormData(form);
        fetch(form.action, { method: "POST", body: fd, headers: { Accept: "application/json" } })
          .then(function () {
            toast(form.getAttribute("data-success") || t("subscribed", "Thanks! Please confirm your email."));
            form.reset();
          })
          .catch(function () { toast(t("formError", "Something went wrong. Please try again.")); });
      });
    });
  }

  /* ---------------- boot ---------------- */
  /* Each step is isolated: if one throws, the rest still initialise.
     Previously a single failure took down variant selection and add-to-cart. */
  function step(name, fn) {
    try { fn(); }
    catch (err) { if (window.console) console.error("[vutoria] " + name + " failed:", err); }
  }

  /** Bind once per element, even when boot() re-runs (theme editor reloads). */
  function once(el, key) {
    var flag = "vutBound" + key;
    if (el.dataset[flag]) return false;
    el.dataset[flag] = "1";
    return true;
  }

  /**
   * Move every overlay to <body>.
   * The size dialog lives inside .vut-buybox, which is position:sticky on
   * desktop — and sticky creates its own stacking context. Inside it, the
   * dialog's z-index cannot beat the page-level backdrop, so the dialog was
   * rendered *behind* the dim layer and could not be clicked.
   */
  function liftOverlays() {
    $$(".vut-dialog, .vut-drawer, .vut-popup").forEach(function (el) {
      if (el.parentNode !== document.body) document.body.appendChild(el);
    });
  }

  function boot() {
    step("overlays", liftOverlays);
    step("search",   function () { $$("[data-search-root]").forEach(initSearch); });
    step("wishlist", function () { Wishlist.paint(); });
    step("cart",     function () { Cart.fetchState().catch(function () {}); startTimer(); });
    step("product",  initProduct);
    step("filters",  initFilters);
    step("videos",   initVideos);
    step("forms",    initForms);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  // re-init when the theme editor re-renders a section
  document.addEventListener("shopify:section:load", boot);

  window.Vutoria = { Cart: Cart, Wishlist: Wishlist, toast: toast, openLayer: openLayer, closeTop: closeTop };
})();
